import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { IMG } from "@/lib/site";
import { useT } from "@/lib/i18n";

const HomePress = () => {
  const t = useT();
  return (
    <section className="py-24 md:py-32 bg-ivory" data-testid="press-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-5">
            <div className="watermark-hide relative aspect-[4/5] rounded-tr-[4rem] rounded-bl-[4rem] overflow-hidden bg-sand">
              <img
                src={IMG.armsCrossed}
                alt="Marta Montardit en La Vanguardia"
                className="w-full h-full object-cover object-[center_30%] scale-105"
                loading="lazy"
                decoding="async"
              />
            </div>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("home.press.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal leading-[1.05]">
              {t("home.press.title1")} <span className="italic">{t("home.press.title2")}</span>.
            </h2>

            <div className="mt-10 space-y-6">
              <div className="flex items-baseline gap-4">
                <span className="font-serif italic text-3xl md:text-4xl text-charcoal">La Vanguardia</span>
              </div>
              <div className="flex items-baseline gap-4">
                <span className="font-sans font-bold text-2xl md:text-3xl tracking-tight text-charcoal">RAC1</span>
              </div>
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-3xl md:text-4xl text-charcoal">Primera Persona</span>
              </div>
            </div>

            <blockquote className="mt-12 border-l-2 border-terracotta pl-6">
              <p className="font-serif italic text-2xl md:text-3xl text-charcoal leading-snug max-w-xl">
                {t("home.press.quote")}
              </p>
              <footer className="mt-4 text-[11px] tracking-[0.25em] uppercase text-charcoal/50">— Marta Montardit</footer>
            </blockquote>

            <Link
              to="/prensa"
              data-testid="press-cta"
              className="mt-10 inline-flex items-center gap-2 text-charcoal text-sm font-medium border-b border-terracotta pb-1 hover:text-terracotta transition-colors"
            >
              {t("home.press.cta")} <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomePress;
